import { ErrorHandler, Injector, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { EnvConfigurationService } from '@services/env/env-configuration.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { UserService } from '@services/user/user.service';
import { ApplicationInsightsService } from './application-insights.service';
import { ErrorDisplayService } from './error-display-service';

function errorHandlerFactory(
    snackbarService: SnackbarService,
    envConfigurationService: EnvConfigurationService,
    userService: UserService,
    // Injector is used instead of injecting ErrorService directly, because ErrorService pulls in HttpClient,
    // whose ErrorHandlerInterceptor requests the ErrorHandler currently being constructed, causing NG0200.
    injector: Injector,
    router: Router
) {
    if (
        envConfigurationService.configuration.appInsightsConnectionString !== null &&
        envConfigurationService.configuration.appInsightsConnectionString !== undefined &&
        envConfigurationService.configuration.appInsightsConnectionString !== ''
    ) {
        return new ApplicationinsightsAngularpluginErrorService();
    } else {
        return new ErrorDisplayService(snackbarService, envConfigurationService, userService, injector, router);
    }
}

@NgModule({
    declarations: [],
    imports: [],
    exports: [],
    providers: [
        ApplicationInsightsService,
        {
            provide: ErrorHandler,
            useFactory: errorHandlerFactory,
            deps: [SnackbarService, EnvConfigurationService, UserService, Injector, Router],
        },
    ],
})
export class ErrorHandlingModule {
    constructor(
        private appInsightsService: ApplicationInsightsService,
        private envService: EnvConfigurationService
    ) {
        // `appInsightsService` might appear unused, but it's injected intentionally to initialize the service when the app starts
    }
}
